import Splide from '@splidejs/splide';
import { isMobileScreen } from './utils';

const setMobileImages = (images) => {
  if (!isMobileScreen()) return;

  images.forEach((img) => {
    img.setAttribute('src', img.getAttribute('data-mobile-img-src'));
    img.setAttribute('alt', img.getAttribute('data-mobile-img-alt'));
  });
};

const checkNavAndAdjustBody = () => {
  if (document.querySelector('body div.nav')) {
    document.body.classList.add('has-nav');
  }
};

const onHeaderBannerLoad = () => {
  checkNavAndAdjustBody(); // Call this function to adjust the body based on the presence of div.nav

  const headerBanners = document.getElementsByClassName('header-banner');

  if (!headerBanners) return;

  Array.from(headerBanners).forEach((item) => {
    const headerBannerCarousel = item.querySelectorAll('[data-hb-carousel] li');
    const headerBannerCarouselImages = item.querySelectorAll(
      '[data-hb-carousel] li img'
    );

    let isPaused = false; 

    const splideInstance = new Splide(item, {
      type: headerBannerCarousel?.length > 1 ? 'loop' : null,
      focus: 0,
      pagination: headerBannerCarousel?.length > 1,
      drag: headerBannerCarousel?.length > 1,
    }).mount();

    let currentSlideIndex = 0;

    setInterval(() => {
      if (!isPaused) {
        currentSlideIndex++;
        // If the index exceeds the total number of slides, reset it to 0
        if (currentSlideIndex >= headerBannerCarousel.length) {
          currentSlideIndex = 0;
        }
        // Go to the next slide based on the updated index
        splideInstance.go(currentSlideIndex);
      }
    }, 3000);

    // Pause on mouseover
    item.addEventListener('mouseover', () => {
      isPaused = true;
    });

    // Resume on mouseout
    item.addEventListener('mouseout', () => {
      if (isPaused) {
        isPaused = false;
      }
    });

    setMobileImages(headerBannerCarouselImages);
  });
};

export default onHeaderBannerLoad;
